export class InterviewOptionsEnum {
    readonly id: number;
    readonly label: string;

    public isIn = (arr: { id: number }[]): boolean => {
        arr = arr != null ? arr : [];
        return arr.findIndex(t => t.id === this.id) >= 0;
    };

    protected constructor(id: number, label: string) {
        this.id = id;
        this.label = label;
    }

    public static IN_PERSON = new InterviewOptionsEnum(10, "In person");
    public static PHONE = new InterviewOptionsEnum(20, "Phone");
    public static VIDEO = new InterviewOptionsEnum(30, "Video");

    public static asArray = () => {
        return [InterviewOptionsEnum.IN_PERSON, InterviewOptionsEnum.PHONE, InterviewOptionsEnum.VIDEO];
    };

    public static fromId = (id: number) => {
        return InterviewOptionsEnum.asArray().find(t => t.id === id);
    };
}
